import React from 'react';

const BaseLayout = (props) => {
  return (
    <div className="fg1 flex">
      {props.children}
    </div>
  )
}

export default BaseLayout;


/** WEBPACK FOOTER **
 ** ./src/components/layouts/BaseLayout.js
 **/